const InovatorMuda: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-xl font-semibold mb-3">💡 Lomba Innovative Technology: Tempat Lahirnya Ide-Ide Gila yang Jadi Nyata!</h2>

            <p className="mb-4">
                Lomba <span className="font-semibold">Innovative Technology</span> adalah panggung bagi para siswa untuk menunjukkan kreativitas dan kemampuan problem-solving mereka lewat teknologi. Di sinilah berbagai ide unik dan cemerlang bermunculan, mulai dari <span className="font-medium">aplikasi pintar, sistem IoT sederhana, hingga alat bantu kehidupan sehari-hari</span> yang belum pernah terpikir sebelumnya!
            </p>

            <p className="mb-4">
                Banyak karya yang membuat para juri terkesima karena <span className="font-semibold">out of the box dan punya dampak nyata</span>. Misalnya, ada tim yang menciptakan alat pendeteksi banjir sederhana berbasis sensor, ada juga yang membuat aplikasi pengingat minum air untuk lansia.
            </p>

            <h3 className="text-lg font-semibold mb-2">🚀 Apa yang Membuat Karya Mereka Istimewa?</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Berangkat dari masalah nyata yang mereka temui di lingkungan sekitar.</li>
                <li>Solusinya sederhana, tapi sangat berguna dan mudah dipahami.</li>
                <li>Dibuat dengan semangat belajar, bukan sekadar ikut lomba.</li>
            </ul>
            <p>
                Lomba ini bukan tentang siapa yang paling jago teknologi, tapi siapa yang paling <span className="font-semibold">peduli, kreatif, dan berani mencoba sesuatu yang baru</span>. Karena dari ide kecil yang sederhana, bisa muncul solusi besar yang mengubah dunia.
            </p>
        </div>
    )
}
export default InovatorMuda